// Performance: Uses THREE.Points (1 draw call) instead of 150 individual <a-entity>
// sphere meshes (150 draw calls). At steady state, the starfield was responsible for
// 150 of ~178 total draw calls — the single largest optimization available.
// Quest 2 shows measurable frame pressure above ~200-250 draw calls in WebXR.

AFRAME.registerComponent('starfield', {
  schema: {
    count:   { type: 'number', default: 150 },
    minDist: { type: 'number', default: 30 },
    maxDist: { type: 'number', default: 50 },
  },

  init: function () {
    const { THREE } = AFRAME;
    const positions = new Float32Array(this.data.count * 3);

    for (let i = 0; i < this.data.count; i++) {
      const theta = Math.random() * Math.PI * 2;
      const phi   = Math.acos(2 * Math.random() - 1);
      const r     = this.data.minDist + Math.random() * (this.data.maxDist - this.data.minDist);

      positions[i * 3]     = r * Math.sin(phi) * Math.cos(theta);
      positions[i * 3 + 1] = r * Math.cos(phi);
      positions[i * 3 + 2] = r * Math.sin(phi) * Math.sin(theta);
    }

    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    const material = new THREE.PointsMaterial({
      color: 0xffffff,
      size: 0.12,
      sizeAttenuation: true,
    });
    const points = new THREE.Points(geometry, material);
    this.el.setObject3D('starfield', points);
  },

  remove: function () {
    const points = this.el.getObject3D('starfield');
    if (points) {
      points.geometry.dispose();
      points.material.dispose();
      this.el.removeObject3D('starfield');
    }
  },
});

if (import.meta.hot) { import.meta.hot.decline(); }
